export default "__VITE_ASSET__326bb54d__"